







"use strict";







class WebStorageManager {
    








    constructor(prefix = "_fx", type = "session") {
        this.prefix = prefix + "_";

        if (type === "session") {
            this.storage = window.sessionStorage;
        } else if (type === "local") {
            this.storage = window.localStorage;
        } else {
            this.storage = window.sessionStorage;
        }
    }

    





    getItem(key) {
        return this.storage.getItem(this.prefix + key);
    }

    





    setItem(key, value) {
        this.storage.setItem(this.prefix + key, value);
    }

    




    removeItem(key) {
        this.storage.removeItem(this.prefix + key);
    }


    



    clear() {
        this.storage.clear();
    }

    





    key(index) {
        return this.storage.key(index);
    }

    




    get length() {
        return this.storage.length;
    }
}

module.exports = {
    WebStorageManager
};
